import { render, staticRenderFns } from "./EditPickUpGroupModal.vue?vue&type=template&id=fc36a61a&"
import script from "./EditPickUpGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditPickUpGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports